module.exports = __webpack_public_path__ + "img/23.9f6723bb.jpg";